import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog?limit=30").then(({ data }) => setPosts(data)); }, []);

  return (
    <main className="max-w-[1480px] mx-auto px-6 md:px-12 py-14" data-testid="journal-page">
      <Seo title="Journal"
           description="Editorial writing from the Aura & Co. atelier — craft, care, and the quiet pleasure of fine jewelry."
           jsonLd={{
             "@context": "https://schema.org",
             "@type": "Blog",
             "name": "Aura & Co. Journal",
             "description": "Editorial from the atelier."
           }} />
      <p className="eyebrow text-neutral-600">The Journal</p>
      <h1 className="font-serif text-4xl md:text-6xl mt-2 mb-12">Words from the atelier.</h1>
      {posts.length === 0 ? (
        <p className="text-neutral-500 text-sm">No posts yet — check back soon.</p>
      ) : (
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {posts.map((p, i) => (
            <Link key={p.id} to={`/journal/${p.slug}`} className={`group rise rise-d${(i%4)+1}`} data-testid={`post-${p.slug}`}>
              <div className="aspect-[4/3] bg-sand overflow-hidden product-img-wrap">
                {p.cover_image && <img src={p.cover_image} alt={p.title} className="product-img w-full h-full object-cover" />}
              </div>
              <p className="eyebrow text-neutral-500 mt-6">Editorial · {new Date(p.created_at).getFullYear()}</p>
              <h2 className="font-serif text-2xl mt-2 leading-tight group-hover:text-[var(--gold)] transition-colors">{p.title}</h2>
              {p.excerpt && <p className="text-sm text-neutral-600 mt-3">{p.excerpt}</p>}
              <p className="btn-ghost mt-4 inline-flex">Read more <ArrowRight className="w-4 h-4 ml-1" strokeWidth={1.25} /></p>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
